module.exports = __webpack_public_path__ + "assets/img/4f67-ca.svg";